export enum FamilyHubUserStatus {
    Archived = "Archived",
    Active = "Active",
    ResidentDeleted = "Resident deleted"
}

export enum FamilyHubUserStatusReason {
    ResidentDeleted = "Resident deleted"
}